import { useEffect, useRef, useState } from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { BouncingBox } from "../../BouncingBox/BouncingBox";
import meowSound from "../../../assets/sounds/meow.mp3";

export default function KellyanButton() {
  const [boxes, setBoxes] = useState([]);
  const textColor = useColorModeValue("#4b635e", "#E9A6A6");
  const meowAudio = useRef(null);

  useEffect(() => {
    meowAudio.current = new Audio(meowSound);
  }, []);

  const handleTextClick = () => {
    if (meowAudio.current) {
      meowAudio.current.currentTime = 0;
      meowAudio.current.play();
    }
    const newBox = { id: Date.now() };
    setBoxes((prev) => [...prev, newBox]);
  };

  return (
    <Box>
      <Text
        color={textColor}
        fontFamily="Lilita One"
        fontSize="xl"
        cursor="pointer"
        onClick={handleTextClick}
      >
        Kellyan
      </Text>

      {boxes.map((box) => (
        <BouncingBox key={box.id} id={box.id} image="butterman" />
      ))}
    </Box>
  );
}
